import ChartDatasets from "./datasets/dataset_helper"
import ChartOptions from "./options/options"
export default {
    name: "CountesChartComponent",
    datasets: [],
    labels: "months",
    loading: true,
    style:"height: 150px",
    options: ChartOptions.getCountesChartOptions(),
    config: {
        datasets: {
            today: {
                borderColor: "#a1704b",
            },
            yesterday: {
                borderColor: "#d2a17d",
            }
        }

    }
}